import React, {Component} from 'react'
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'
import {Spin, Form, Row, Select, DatePicker, Col, Card, Button} from 'antd'
import Moment from 'moment'
import {connect} from 'react-redux'

import {fetchBarCategory} from 'appRedux/actions/Reports'

import getDate from 'util/ConfigDates'

const FormItem = Form.Item

class BarChrt extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dateFrom: getDate('dateFrom'),
      dateTo: getDate('dateTo'),
      validateDateFrom: '',
      helpDateFrom: '',
      validateDateTo: '',
      helpDateTo: '',
    }
    this.props.fetchBarCategory(this.state)
  }

  onHandleClick = event => {
    event.preventDefault()
    if (this.state.dateFrom !== '' && this.state.dateTo !== '') {
      this.props.fetchBarCategory(this.state)
    } else {
      if (this.state.dateFrom == '') {
        this.setState({
          validateDateFrom: 'error',
          helpDateFrom: 'Fecha desde es un campo obligatorio.',
        })
      } else {
        this.setState({validateStatusBranchOffice: '', helpBrachOffice: ''})
      }
      if (this.state.dateTo == '') {
        this.setState({
          validateDateTo: 'error',
          helpDateTo: 'Fecha hasta es un campo obligatorio.',
        })
      } else {
        this.setState({validateStatusBranchOffice: '', helpBrachOffice: ''})
      }
    }
  }

  onClickDateFrom = (date, dateString) => {
    this.setState({
      dateFrom: dateString,
      validateDateFrom: '',
      helpDateFrom: '',
    })
  }

  onClickDateTo = (date, dateString) => {
    this.setState({dateTo: dateString, validateDateTo: '', helpDateTo: ''})
  }

  render() {
    let showBar = () => {
      const data = this.props.barCategory.map((element, index) => {
        return {
          category: element.category,
          Canjeados: element.redeemed,
          Comprados: element.purchased,
        }
      })

      if (!data) {
        return <Spin className="gx-loader-container" />
      } else {
        return (
          <ResponsiveContainer width="100%" height={400}>
            <BarChart
              data={data}
              margin={{top: 10, right: 0, left: -15, bottom: 0}}
            >
              <XAxis dataKey="category" />
              <YAxis />
              <CartesianGrid strokeDasharray="3 3" />
              <Tooltip />
              <Legend />
              <Bar dataKey="Canjeados" fill="#088A08" />
              <Bar dataKey="Comprados" fill="#B62A0C" />
            </BarChart>
          </ResponsiveContainer>
        )
      }
    }

    return (
      <div>
        <Card>
          <Form onSubmit={this.onHandleClick}>
            <Row>
              <Col span={10}>
                <FormItem
                  label="Desde :"
                  validateStatus={this.state.validateDateFrom}
                  help={this.state.helpDateFrom}
                  labelCol={{xs: 24, sm: 9, lg: 9, md: 9}}
                >
                  <DatePicker
                    defaultValue={Moment(this.state.dateFrom, 'YYYY-MM-DD')}
                    className="gx-mb-3 gx-w-100"
                    onChange={this.onClickDateFrom}
                  />
                </FormItem>
              </Col>
              <Col span={10}>
                <FormItem
                  label="Hasta : "
                  validateStatus={this.state.validateDateTo}
                  help={this.state.helpDateTo}
                  labelCol={{xs: 24, sm: 9, lg: 9, md: 9}}
                >
                  <DatePicker
                    defaultValue={Moment(this.state.dateTo, 'YYYY-MM-DD')}
                    className="gx-mb-3 gx-w-100"
                    onChange={this.onClickDateTo}
                  />
                </FormItem>
              </Col>
              <Col span={4} className="gx-text-right">
                <Button type="primary" onClick={this.onHandleClick}>
                  <i className="icon icon-search" />
                </Button>
              </Col>
            </Row>
          </Form>
        </Card>
        {showBar()}
      </div>
    )
  }
}

function mapStateToProps({reports}) {
  const {barCategory} = reports
  return {
    barCategory,
  }
}

export default connect(
  mapStateToProps,
  {fetchBarCategory},
)(BarChrt)



// WEBPACK FOOTER //
// ./src/routes/main/Reports/bar/Bar.js